<app-empty
  svgSrc="assets/core/images/pienso-blocks.svg"
  [title]="title"
  [body]="body"
>
  @if (hasHomeAccess) {
    <p-button-secondary (click)="redirectToHome()">Go to Home</p-button-secondary>
  }
</app-empty>
